import React, { FC } from 'react';
import { TypeVideoEmbedFields } from '@/core/generated-types';
import classNames from 'classnames';

export interface VideoEmbedProps extends TypeVideoEmbedFields {
  classes?: string;
}

export const VideoEmbed: FC<VideoEmbedProps> = ({
  entryName,
  platform,
  videoId,
  videoParams = '',
  classes = '',
}) => {
  const src =
    platform === 'Vimeo'
      ? `https://player.vimeo.com/video/${videoId}${videoParams}`
      : `https://www.youtube.com/embed/${videoId}${videoParams}`;

  // These classses are used if none are passed in from a parent component:
  const defaultClasses = 'w-full h-[270px] md:w-[700px] md:h-[420px] mx-auto';

  return (
    <iframe
      data-testid={`video-embed-${entryName}`}
      src={src}
      allow="fullscreen"
      allowFullScreen
      className={classNames(classes ? classes : defaultClasses)}
      suppressHydrationWarning={true}
    ></iframe>
  );
};
